import { WORKERTOPIC } from 'worker/app-workers/shared/worker-topic.constants';

export class WorkerMessage {

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(public topic: WORKERTOPIC, public id: string, public data: any) {
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static getInstance(value: any): WorkerMessage {
        const { topic, id, data } = value;
        return new WorkerMessage(topic, id, data);
    }
}
